<template>

    <v-row 
        no-gutters
        class="background-submenu"
    >
        <v-col>

            <v-list>

                <!-- <div class="title-submenu">
                     {{ menu.children[0].title }} hola
                </div> -->

                <v-list-item 
                    link 
                    tile
                    :to="`/${$i18n.locale}/maquinaria/enfardadores`"
                >
                    <!-- :to="`${rutas[0].path}`" -->
                    <v-icon size="15" class="icon-submenu" color="#059d8a">mdi-rhombus-medium</v-icon>
                    <!-- <v-icon size="15" class="icon-submenu" :color="menu.color">mdi-rhombus-medium</v-icon> -->
                    <v-list-item-content> 
                        <v-list-item-title class="subtitle-2 pl-5 m-0">
                        <!--  {{ submenu.name }} --> {{ $t('enfardadores') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item 
                    link 
                    tile
                    :to="`/${$i18n.locale}/maquinaria/precintadores`"
                >
                    <v-icon size="15" class="icon-submenu" color="#059d8a">mdi-rhombus-medium</v-icon>
                    <v-list-item-content> 
                        <v-list-item-title class="subtitle-2 pl-5 m-0">
                        <!--  {{ submenu.name }} --> {{ $t('precintadores') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item 
                    link 
                    tile
                    :to="`/${$i18n.locale}/maquinaria/flexadores`"
                >
                    <v-icon size="15" class="icon-submenu" color="#059d8a">mdi-rhombus-medium</v-icon>
                    <v-list-item-content> 
                        <v-list-item-title class="subtitle-2 pl-5 m-0">
                        <!--  {{ submenu.name }} --> {{ $t('flexadores') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item 
                    link 
                    tile
                    :to="`/${$i18n.locale}/maquinaria/porta-fleixos`"
                >
                    <v-icon size="15" class="icon-submenu" color="#059d8a">mdi-rhombus-medium</v-icon>
                    <v-list-item-content> 
                        <v-list-item-title class="subtitle-2 pl-5 m-0">
                        <!--  {{ submenu.name }} --> {{ $t('portafleixos') }}
                        </v-list-item-title>
                    </v-list-item-content>

                </v-list-item>
            </v-list>
        
        </v-col>
    </v-row>

</template>

 <!--  <v-row no-gutters
    class="background-submenu">

    <v-col>
      <v-list>

        <div class="title-submenu" v-if="menu.children2">
          {{ menu.children[0].title }}
        </div>

        <v-list-item link tile
          v-for="(submenu, index) in menu.children" :key="index" 
            :to="submenu.path">
    
            <v-icon size="15" class="icon-submenu" :color="menu.color">mdi-rhombus-medium</v-icon>
                 
            </v-btn>
            <v-list-item-content> 
              <v-list-item-title class="subtitle-2 pl-5 m-0">
                  {{ $t('enfardadores') }}
              </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
      </v-list>
    
    </v-col>
  </v-row> -->
    <!--    
        <v-menu
            transition="slide-y-transition"
            bottom
            color="white"
            open-on-hover offset-y
        >
            <template v-slot:activator="{ on }">
                <v-btn
                    color="white"
                    v-on="on"
                    class="menu-principal--with-children"
                    text
                    :to="`${rutas[0].path}`"
                > 
                
            </template>
        </v-menu> 
    -->

<script>

// import IconBase from '@/components/elements/IconBase.vue'
// import arrowDown from '@/assets/svg/arrowDown.vue'
// import SubmenuItem from '@/components/elements/SubmenuItem.vue'

export default {
    name: 'SubmenuMaquinaria',
    components: {
        // IconBase,
        // arrowDown,
        // SubmenuItem,
    },
    methods: {
        triggerClick: function (route){
        this.$router.push(route);
        }
    },
    computed: {
        rutas () {
            return this.$router.options.routes;
        },
        menu () {
            return this.$store.state.menu
        }
    }
    
}
</script>


<style scoped lang="scss">

.background-submenu {
    background: white;
    border-radius: 0 !important;
}

.icon-submenu {
    margin-right: -15px !important;
    padding-right: 0 !important;
    width: 15px !important;
}

/* .column-menu {
    flex-flow: column wrap !important;
    font-size: .65em;
    width: max-content;
    min-width: auto;
    position: absolute;
    background: white;
    padding-top: 20px;
    padding-bottom: 40px;
    border-radius: 0 0 22px 10px;
    border:0;
    border-top: 5px solid rgb(92, 130, 253);
    background-image: linear-gradient(#c8e0fc, #c7fcf2);

    li {
      padding: 10px 25px 0px 0px;

      div {
        border-bottom: 3px solid transparent;
        padding: 6px 10px 4px;
        border-radius: 4px;
      }
      div:hover {
        color: rgb(60, 137, 253);
        cursor: pointer;
        background-color: rgb(255, 255, 255);
      }
    }
} */

</style>